import React from "react";
import { FaStar } from "react-icons/fa";
import TooltippedElement from "../../../../components/TooltippedElement";
import { useTranslation } from "react-i18next";

type Props = {
  isPrimary: boolean
  onClick: () => void
  title?: string
}

const FavoriteStarButton = ({ isPrimary, onClick }: Props) => {
  const { t } = useTranslation();
  const tBase = "views.customers.new-customer.components.FavoriteStarButton";
  const tr = (key: string) => t(`${tBase}.${key}`);

  // ESERV2-1336
  return (
    <button
      type="button"
      tabIndex={-1}
      onClick={onClick}
      aria-pressed={isPrimary}
      className={`absolute top-[17px] right-[-7px] z-[2] p-0 m-0 leading-none transition-opacity ${
        isPrimary
          ? "opacity-100"
          : "opacity-0 group-hover:opacity-60 hover:!opacity-10 0"
      }`}
    >
      <TooltippedElement
        message={tr("Default")}
        placement="top"
        element={
          <FaStar className={`h-4 w-4 ${isPrimary ? "text-blue-500" : "text-slate-400"}`} />
        }
      />
    </button>
  )
}

export default FavoriteStarButton
